import React from "react";
import { useCurrentAccountStore } from "../../../../../store/currentAccountStore";
import { useQueryAccountAssetOptions } from "../../../../../store/useQueryAccountAssetOptions";
import { Selector, SelectorProps } from "../../../../selector/Selector";

type AssetFilterProps = Omit<
  SelectorProps<string>,
  "values" | "onChange" | "options" | "isLoading" | "placeholder"
> & {
  values: string[];
  onChange: (values: string[]) => void;
};

export function AssetFilter({
  values,
  onChange,
  ...props
}: AssetFilterProps): React.ReactElement {
  const accountId = useCurrentAccountStore(({ accountId }) => accountId);

  const queryAccountAssetOptions = useQueryAccountAssetOptions(accountId);

  return (
    <Selector
      values={values}
      onChange={onChange}
      options={queryAccountAssetOptions.data ?? []}
      isLoading={queryAccountAssetOptions.data === undefined}
      placeholder="Asset"
      enableDoubleColumn
      enableSearch
      enableBulkSelect
      enableDeselect
      enableMultiSelect
      moveSelectedToTop
      {...props}
    />
  );
}
